import { render } from "./ImagensCancelamento.vue?vue&type=template&id=8e609326&scoped=true"
import script from "./ImagensCancelamento.vue?vue&type=script&lang=js"
export * from "./ImagensCancelamento.vue?vue&type=script&lang=js"

import "./ImagensCancelamento.vue?vue&type=style&index=0&id=8e609326&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e609326"]])

export default __exports__